import React from 'react';
import { Tabs as MuiTabs, TabsProps as MuiTabsProps, styled } from '@mui/material';
import { Tab, TabProps } from './Tab';

export type TabsProps = Pick<MuiTabsProps, 'value' | 'onChange' | 'scrollButtons'> & {
  styleVariant?: 'primary' | 'grey' | 'underline' | 'underline-filled' | 'white-border';
  fullWidth?: boolean;
  tabs: (Omit<TabProps, 'styleVariant'> | false)[];
};

const StyledTabs = styled(MuiTabs, {
  shouldForwardProp: (prop) => prop !== 'styleVariant' && prop !== 'fullWidth',
})<Omit<TabsProps, 'tabs'>>(({ theme, styleVariant, fullWidth }) => ({
  width: fullWidth ? '100%' : undefined,
  borderBottom:
    styleVariant === 'underline' || styleVariant === 'underline-filled'
      ? `1px solid ${theme.custom.colours?.grey200}`
      : undefined,
  backgroundColor: styleVariant === 'white-border' ? theme.custom.colours?.grey50 : undefined,
  border: styleVariant === 'white-border' ? `1px solid ${theme.custom.colours?.grey200}` : undefined,
  borderRadius: styleVariant === 'white-border' ? '12px' : undefined,
  padding: styleVariant === 'white-border' ? '6px' : undefined,
  '& .MuiTabs-indicator': {
    backgroundColor: theme.palette.primary.main,
    display: styleVariant !== 'underline' && styleVariant !== 'underline-filled' ? 'none' : undefined,
  },
}));

export const Tabs: React.FC<TabsProps> = ({ tabs = [], styleVariant = 'underline', fullWidth = false, ...props }) => {
  return (
    <StyledTabs
      {...props}
      styleVariant={styleVariant}
      variant={fullWidth ? 'fullWidth' : 'scrollable'}
      fullWidth={fullWidth}
    >
      {tabs.map((tab, index) => {
        if (!tab) return null;
        return <Tab key={index} {...tab} styleVariant={styleVariant} />;
      })}
    </StyledTabs>
  );
};
